import InviteCustomers from "./InviteCustomers";
export default InviteCustomers;
